import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  contentsValueState,
  imgBase64State,
  imgFileState,
  isCreateProfilePopState,
  isDetailState,
  isEditState,
  isProfilePageState,
  popContValueState,
  popState
} from "../recoil/contentsAtom";
import { useLocation } from "react-router-dom";
import { isProfileOwnerState } from "recoil/userInfoAtom";

function ResetInfo() {
  const isDetail = useRecoilValue(isDetailState);
  const isCreateProfilePop = useRecoilValue(isCreateProfilePopState);
  const popOpen = useRecoilValue(popState);
  const [isEdit, setIsEdit] = useRecoilState(isEditState);
  const setPopContValue = useSetRecoilState(popContValueState);
  const setContentsValue = useSetRecoilState(contentsValueState);
  const setIsProfilePage = useSetRecoilState(isProfilePageState);
  const setImgBase64 = useSetRecoilState(imgBase64State);
  const setImgFile = useSetRecoilState(imgFileState);
  const setisProfileOwner = useSetRecoilState(isProfileOwnerState);
  const location = useLocation();

  useEffect(() => {
    if (isDetail) {
      document.body.style.overflow = "hidden";
      return;
    }
    document.body.style.overflow = "auto";
  }, [isDetail]);

  useEffect(() => {
    if (isCreateProfilePop) {
      document.body.style.overflow = "hidden";
      return;
    }
    document.body.style.overflow = "auto";
  }, [isCreateProfilePop]);

  useEffect(() => {
    if (!isEdit && !popOpen) {
      setPopContValue({ title: "", content: "" });
    }
  }, [isEdit, popOpen]);

  useEffect(() => {
    if (!popOpen) {
      setPopContValue({ title: "", content: "" });
      setContentsValue("");
      setIsEdit(false);
      setImgBase64([]);
      setImgFile(null);

      document.body.style.overflow = "auto";
    } else {
      document.body.style.overflow = "hidden";
      return;
    }
  }, [popOpen]);

  useEffect(() => {
    setIsProfilePage(location.pathname.split("/")[1] === "profile");
    setisProfileOwner(false);
  }, [location.pathname]);

  return null;
}

export default ResetInfo;
